import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import Processing from "../Generic/Processing";
import MailboxAccressRequests from "./mailboxAccressRequests";
import MailboxAccressRequestsForManager from "./mailboxAccressRequestsForManager";
import { getTenantMailboxes } from "./tenantApiCall";

function MailboxAccessRequest() {
    const UserInfo = useSelector((state: RootState) => state.UserInformation);
    const [isMailboxManager, setIsMailboxManager] = useState<boolean | undefined>(undefined);
    const [showMyRequests, setShowMyRequests] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            const mailboxes = await getTenantMailboxes();
            let userIsMailboxManager = false;
            for (const mailbox of mailboxes) {
                if (mailbox.managerID === UserInfo.userID) {
                    userIsMailboxManager = true;
                    break;
                }
            }
            setIsMailboxManager(userIsMailboxManager);
        })();
    }, [UserInfo.userID]);

    if (isMailboxManager == undefined) {
        return (
            <Processing>
                <p>loading...</p>
            </Processing>
        );
    }

    if (isMailboxManager === true && showMyRequests) {
        return (
            <MailboxAccressRequests
                isManager={true}
                onBack={() => setShowMyRequests(false)}
            />
        );
    }

    if (isMailboxManager === true) {
        return <MailboxAccressRequestsForManager onShowMyRequests={() => setShowMyRequests(true)} />;
    }

    return <MailboxAccressRequests isManager={false} />;
}
export default MailboxAccessRequest;
